import auth from '@/services/auth';
import service from '@/services/linesheet';
import { promiseError } from '@/store/utils';
import { POST_LOADER_DELAY } from '@/constants';
import { Linesheet } from './types';
import messages from './messages';

const methods = {
  askDelete(linesheet: Linesheet) {
    const contentAsk = this.$formatMessage(
      messages.LINESHEET_DELETE_ASK,
      linesheet.title,
    );
    return new Promise(resolve => {
      this.$store.commit('dialog/CREATE', {
        title: 'Delete linesheet?',
        content: contentAsk,
        compact: true,
        buttons: [{
          text: 'No, don\'t delete',
          click: (dialog: any) => {
            resolve(false);
            dialog.close();
          },
        }, {
          text: 'Yes, delete',
          click: (dialog: any) => {
            const linesheetId = linesheet.id;
            const contentConfirm = this.$formatMessage(
              messages.LINESHEET_DELETE_CONFIRM,
              linesheet.title,
            );
            this.$store.commit('loader/ADD', {
              title: contentConfirm,
              promise: service.remove(linesheetId)
              .then(() => {
                if (this.$store.state.linesheets) {
                  this.$store.commit(`linesheets/REMOVE`, linesheetId);
                }
                resolve(true);
                dialog.close();
              }, () => {
                promiseError('LINESHEET_REMOVE', this.$store.commit),
                this.$store.commit('dialog/CREATE', {
                  title: 'Error :(',
                  content: messages.ERROR_LINESHEET_DELETE,
                  compact: true,
                  buttons: [{
                    text: 'Close',
                    click: (subDialog: any) => subDialog.close(),
                  }],
                });
              }),
            });
          },
        }],
      });
    });
  },
  createLinesheet(context: any) {
    // TODO: add linesheetLimitReached getter
    context.$store.commit('loader/ADD', {
      title: 'Creating linesheet',
      promise: context.create().then(
        (linesheet: Linesheet) => {
          context.$router.push({
            name: 'linesheet',
            params: {
              linesheetId: linesheet.id,
            },
          });
        }).catch((error: any) => {
          console.error(error);

          this.$store.commit('dialog/CREATE', {
            title: 'Error :(',
            content: messages.ERROR_LINESHEET_CREATE,
            compact: true,
            delay: POST_LOADER_DELAY,
            buttons: [
              {
                text: 'Close',
                click: (dialog: any) => dialog.close(),
              },
            ],
          });
        }),
    });
  },
  loadError(context: any, error: any) {
    const errorKey = `ERROR_${error.code}`;
    const message = messages[errorKey] || messages.ERROR_LINESHEET_LOAD;
    const userLoggedIn = !!auth.getCurrentToken();
    const buttons = [];

    // don't add reload button if linesheet doesn't exist
    if (error.code !== 'LINESHEET_NOT_FOUND') {
      buttons.push({
        text: 'Try again',
        click: (dialog: any) => {
          dialog.close();
          context.$router.go();
        },
      });
    }

    buttons.push(
      userLoggedIn
      ? {
        text: 'View all linesheets',
        click: (dialog: any) => {
          dialog.close();
          context.$router.push({ name: 'linesheets' });
        },
      }
      : {
        text: 'Back to homepage',
        click: () => {
          window.location.href = '/';
        },
      },
    );

    context.$store.commit('dialog/CREATE', {
      title: 'Load error',
      content: message,
      compact: true,
      delay: POST_LOADER_DELAY,
      buttons,
    });
  },
} as any;

const uploadFormats = {
  jpg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
};

export {
  messages,
  methods,
  uploadFormats,
};
